var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import styled from 'styled-components';
import TargettedSystemContext from '../../context/targetted-system-context';
import WindowStateContext from '../../context/window-state-context';
import { TargettedSystems } from '../../helpers/constants';
import { getGeometryStyle, getMaximumWidth, getMinimumHeight, getMinimumWidth, getTextAlignment } from '../../helpers/styles';
import Checkbox from '../Checkbox';
var StyledGroupBox = styled.div.attrs(function (props) { return ({
    className: props.type,
}); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  ", "\n  min-width: ", ";\n  max-width: ", ";\n  border: ", ";\n  border-left-color: ", ";\n  border-top-color: ", ";\n  border-right-color: ", ";\n  border-bottom-color: ", ";\n  > fieldset {\n    min-height: ", ";\n    border: ", ";\n    border-radius: ", ";\n  }\n  > fieldset legend {\n    text-align: ", ";\n  }\n  > fieldset div {\n    justify-content: ", ";\n  }\n"], ["\n  ", "\n  ", "\n  min-width: ", ";\n  max-width: ", ";\n  border: ", ";\n  border-left-color: ",
    ";\n  border-top-color: ",
    ";\n  border-right-color: ",
    ";\n  border-bottom-color: ",
    ";\n  > fieldset {\n    min-height: ", ";\n    border: ", ";\n    border-radius: ",
    ";\n  }\n  > fieldset legend {\n    text-align: ", ";\n  }\n  > fieldset div {\n    justify-content: ", ";\n  }\n"])), function (_a) {
    var geometry = _a.attributes.geometry;
    return getGeometryStyle(geometry);
}, function (_a) {
    var attributes = _a.attributes;
    return getTextAlignment(attributes.alignment);
}, function (_a) {
    var minimumSize = _a.minimumSize;
    return getMinimumWidth(minimumSize);
}, function (_a) {
    var maximumSize = _a.maximumSize;
    return getMaximumWidth(maximumSize);
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.groupBox.border;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.groupBox.borderColor.left;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.groupBox.borderColor.top;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.groupBox.borderColor.right;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.groupBox.borderColor.bottom;
}, function (_a) {
    var minimumSize = _a.minimumSize;
    return getMinimumHeight(minimumSize);
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.groupBox.fieldset.border;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.groupBox.fieldset.borderRadius;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    var _b;
    return (_b = windowTheme.groupBox.legend) === null || _b === void 0 ? void 0 : _b.textalign;
}, function (_a) {
    var attributes = _a.attributes;
    return attributes === null || attributes === void 0 ? void 0 : attributes.justifyContent;
});
var StyledTitle = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-weight: bold;\n  color: ", ";\n"], ["\n  font-weight: bold;\n  color: ", ";\n"])), function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.groupBox.title.color;
});
var GroupBox = function (props) {
    var children = props.children, identifier = props.identifier, type = props.type, restProps = __rest(props, ["children", "identifier", "type"]), title = props.attributes.title;
    var targetSystem = useContext(TargettedSystemContext);
    if (targetSystem === TargettedSystems.CATIZ) {
        props.attributes.text = title;
    }
    var fields = useContext(WindowStateContext).fields;
    return (React.createElement(StyledGroupBox, __assign({}, restProps),
        React.createElement("fieldset", { disabled: fields[identifier] === false },
            title && (React.createElement("legend", null,
                React.createElement(StyledTitle, { windowTheme: restProps.windowTheme }, targetSystem !== TargettedSystems.HERMESYS ? (React.createElement(Checkbox, __assign({ identifier: identifier }, restProps))) : (title)))),
            children)));
};
export default GroupBox;
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map